module.exports = __webpack_public_path__ + "img/zoetrope6.64c41151.png";